// removed by extract-text-webpack-plugin
module.exports = {"nf-notification-card":"nf-notification-card","nf-button--trash":"nf-button--trash","nf-date-picker":"nf-date-picker","nf-date-picker__label":"nf-date-picker__label","nf-minimums":"nf-minimums","nf-notification-card-button-save":"nf-notification-card-button-save"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationCard/NotificationCard.scss
// module id = 5268
// module chunks = 1